import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PromotionActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Promotion/PromotionBrowser")
	}

	render() {
		return (
			<Activity 
				name="Promotion"
				RenderedComponent={this.RenderedComponent}
				context="Promotion"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PromotionActivity)
